import { __assign, __spreadArrays } from "tslib";
import AnalyticsVersions from "./AnalyticsVersions";
import { resolveAnalyticsGlobalByVersion } from "./Utils";
export var GoogleAnalyticsGTagClientCommands;
(function (GoogleAnalyticsGTagClientCommands) {
    GoogleAnalyticsGTagClientCommands["Config"] = "config";
    GoogleAnalyticsGTagClientCommands["Get"] = "get";
    GoogleAnalyticsGTagClientCommands["Set"] = "set";
    GoogleAnalyticsGTagClientCommands["Event"] = "event";
    GoogleAnalyticsGTagClientCommands["Consent"] = "consent";
})(GoogleAnalyticsGTagClientCommands || (GoogleAnalyticsGTagClientCommands = {}));
/**
 * Client for Google Analytics global site tag(GTag).
 */
var GoogleAnalyticsGTagClient = /** @class */ (function () {
    function GoogleAnalyticsGTagClient(config) {
        var _this = this;
        /**
         * Send a event to gtag
         * @var eventCategory The categorie of the event. It's equal to the trackingPrefix in our case.
         * @var eventAction The action of the event e.g. click/show/manualClose
         * @var eventLabel The label is a combination of the shortend widgettype and
         */
        this.event = function (eventName, params) {
            _this.gtag(GoogleAnalyticsGTagClientCommands.Event, eventName, __assign({}, params));
        };
        /**
         * Set the custom map
         * @var customMap Object containing the custom map properties.
         */
        this.config = function (config) {
            _this.gtag(GoogleAnalyticsGTagClientCommands.Config, config);
        };
        this.set = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            _this.gtag.apply(_this, __spreadArrays([GoogleAnalyticsGTagClientCommands.Set], args));
        };
        this.gtag = resolveAnalyticsGlobalByVersion(AnalyticsVersions.Gtag);
    }
    return GoogleAnalyticsGTagClient;
}());
export default GoogleAnalyticsGTagClient;
//# sourceMappingURL=GoogleAnalyticsGTagClient.js.map